<mat-toolbar *ngIf="patient?.smsNumber" color="primary">
    <span>SMS</span>
    <span class="toolbar-spacer"></span>
    <span *ngIf="patient">{{patient?.smsNumber}}</span>
    <app-user-access-list style="padding-bottom:6px;"></app-user-access-list>
</mat-toolbar>
<mat-toolbar *ngIf="!patient?.smsNumber" color="primary">
    <span>SMS</span>
</mat-toolbar>
<mat-dialog-content *ngIf="patient?.smsNumber">
    <div *ngIf="patient" style="height:80vh;width:40vw;overflow-y: scroll;">
        <app-sms-table [messages]="messages"></app-sms-table>
    </div>
    <div *ngIf="agenda">
        <app-agenda-appointment-table [agenda]="agenda" [show]="['patient']"></app-agenda-appointment-table>
    </div>
</mat-dialog-content>
<mat-dialog-content *ngIf="!patient?.smsNumber">
    <div style="height:10vh;width:40vw;color:red;">
        <h4 style="text-align:center;margin-top:20px;">Ce patient n'a pas de numéro mobile</h4>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <mat-form-field *ngIf="patient?.smsNumber || agenda" class="field-full-width" appearance="legacy">
        <mat-label>Message</mat-label>
        <input matInput placeholder="message" [(ngModel)]="message" value="">
    </mat-form-field>    
    <button mat-button *ngIf="patient?.smsNumber || agenda" (click)="send()">Envoyer</button>
    <button mat-button mat-dialog-close>Fermer</button>
</mat-dialog-actions>